import React, { useEffect, useState } from "react";
import { ApplicationApi, StatusResponse } from "../../lib-api";
import { apiConfiguration } from "../../api-configuration";
import ApplicationDeclined from "./applicationDeclined";
import ApplicationAccepted from "./applicationAccepted";
import Spinner from "../spinner";
import ApplicationManual from "./applicationManual";
import ApplicationContainer from "../applicationContainer";
import ApplicationContent from "../applicationContent";
import TopStripIndicator from "./topStripIndicator";
import { trackEvent } from "../../util/gtm";

interface Props {
    referenceId: number;
}

var calls = 0;
var handle = null;

const ApplicationResponse: React.FunctionComponent<Props> = props => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<StatusResponse>();



    useEffect(() => {
        if (!data) {
            setLoading(true);
        }
        const recall = () => {
            if (calls < 7) {
                handle = setTimeout(load, calls * 2 * 2000);
            } else {
                handle = setTimeout(load, 60000);
            }
        };

        //error handling, maybe interval polling on certain states?
        const load = async () => {
            const api = new ApplicationApi(apiConfiguration);
            try
            {
                const data = await api.apiApplicationsReferenceIdGet({
                    referenceId: props.referenceId
                });
                setData(data);
                if (data.status != "ACCEPTED" && data.status != "DECLINED") {
                    recall();
                }
                //data.status = "ACCEPTED";
            }
            catch (e) {
                "Something went wrong getting the Reference ID " + e.Message;
            }

            setLoading(false);
            console.log("Loaded " + calls + " time/s " + new Date().toLocaleString());
            calls += 1;







        };
        load();

        return () => handle && clearTimeout(handle);
    }, []);

    return (
        <div>
            {loading && <Spinner />}
            {data && StatusRenderer(data, props.referenceId)}
        </div>
    );
};
const GaEvent = () => {
    let userId = window.location.href.substring(window.location.href.lastIndexOf('/') + 1).replace("w-", "");
    trackEvent(
        "ESkat",
        "Bruger " + "refId:" + userId + " gået til Eskat",
        "ESkat",
        userId

    )

}
const StatusRenderer = (data: StatusResponse, referenceId: number) => {
    if (data.status === "ACCEPTED" && data.subStatus === "WAITING_SIGNATURE") {
        return <iframe src={data.digitalSigningUrl}></iframe>;
    } else if (data.status === "DECLINED") {
    return <ApplicationDeclined data={data} referenceId={referenceId} />;
    } else if (data.status === "MANUAL" || data.status === "IN_PROGRESS") {
        return <ApplicationManual data={data} />;
    } else if (data.status === "ACCEPTED") {
        return <ApplicationAccepted data={data} />;
    } else if (data.status === "PENDING_SKAT_CONSENT") {
        return (
            <ApplicationContainer>
                <TopStripIndicator />
                <ApplicationContent className="text-center">
                    <h2 className="text-primary pt-3 pb-5">
                        Du mangler at give samtykke.
          </h2>
                    <p>
                        Du skal nu videre til skat.dk og give samtykke til, at
                        Skatteforvaltningen må videregive dine oplysninger til Basisbank A/S
          </p>
                    <a
                        className="btn whiteButton btn-primary mt-4"
                        href={data.consentUrl}
                       onClick={GaEvent}
                    >
                      Gå til skat
          </a>
               </ApplicationContent>
            </ApplicationContainer>
        );
    } else {
        return (
            <ApplicationContainer>
                <TopStripIndicator errorState={true} />
                <ApplicationContent>
                    <div>
                        <h2 className="text-danger">
                            Din ansøgning er i en ukendt tilstand
            </h2>
                        <p className="text-center py-5">
                            Hvis du mener der er tale om fejl, kontakt venligst vores support.
           </p>
               </div>
             </ApplicationContent>
           </ApplicationContainer>
        );
    }
};

export default ApplicationResponse;
